import { h, Component } from 'preact';
import Border from '../border/border';
import Footer from '../footer/footer';
import Content from '../content/content';
import styles from './trade.css';

export default class Trade extends Component {
  render() {
    return (<div>
      <div className={styles.container}>
        <Content>
          <div className={styles.text}>
            <div className="flex">
              <a href="/"><img className={styles.logo} src="/assets/logo-red.png" alt="Trouble Brewing" /></a>
              <h1 className={styles.title}>Trade Compliance Policy Statement</h1>
            </div>
            <p>This trade compliance policy reflects Trouble Brewing’s commitment to operate in accordance with our code of ethics and business conducts. It also recognizes that failure to meet trade compliance requirements can have serious consequences for us, including damage to the Company’s reputation, monetary penalties, and suspension/revocation of the company’s trading and importing privileges with a resulting negative impact to our customers. Thus, we are committed to the implementation, maintenance and continuous improvement of a robust trade compliance policy, which integrates compliance activities into our business processes.</p>
            <h2>Import Compliance</h2>
            <p>All equipment and inventory imports we facilitate are to be accurately described and applicable under the laws of Singapore.</p>
            <p>All Customs entries shall accurately state all required information, including the importer of record’s name and address, importer number, quantity, value, classification, duty preference eligibility, and country of origin for the imported items.</p>
            <h2>Compliance Responsibility</h2>
            <p>All employees are responsible for supporting the principles contained in this policy.</p>
          </div>
        </Content>
        <Border color="black" />
      </div>
      <Footer />
    </div>);
  }
}



// WEBPACK FOOTER //
// ./components/trade/trade.jsx